import React from 'react';
import queryString from 'query-string';
import DeadLineExpress from 'Assets/deadlineexpress.png';
import DeliveryTrackingStepper from 'Components/deliveryTrackingStepper';
import config from 'config';
import { Navigate } from 'react-router-dom';
import { jobService } from '../_services';
import _ from 'lodash';
import { withRouter } from 'Components/withRouter';
import styles from './DeliveryTrackingPage.module.css';
import IframeTracking from 'Components/IframeTracking';

function FurtherQueryText(props) {

    var pretext = props.delivered != true ?
     "For further queries, " :
     "For queries or requests for the delivery image, ";

     var contactPhoneNumber = config.contactPhoneNumber;
     var email = config.customerServiceEmail;

    return (
        <>
        {pretext} please contact Deadline on {contactPhoneNumber} or email <a className={styles.email} href={`mailto:${email}`}>{email}</a>
        </>
    );
}

class DeliveryTrackingPage extends React.Component {    
    constructor(props) {
        super(props);

        const params = queryString.parse(this.props.router.location.search);
        const token = params.guid;

        this.state = {
            // delivery tracking info
            guid: token || "",
            job_id: -1,
            job_number: "",
            job_status: "",
            booked: false,
            in_progress: false,
            picked_up: false,
            is_enroute: false,
            delivered: false,
            pod_name: "",
            show_on_map: false,
            further_query_text: "",
            mapUrl: "",
            loaded: false,
            tracking_token: ""
        };

        this.openPopup = this.openPopup.bind(this);
    }
        
    componentDidMount(){
        /* calls web API to load the job via the guid provided */
        jobService.GetDeliveryTrackingByGuid(this.state.guid)
        .then(delTracking => {
            this.setState({
                // delivery tracking info
                guid: delTracking.guid || "",
                job_id: delTracking.job_id,
                job_number: (delTracking.job_no > 0? delTracking.job_no : ""),
                job_status: delTracking.job_status || "",
                booked: delTracking.booked,
                in_progress: delTracking.in_progress,
                picked_up: delTracking.picked_up,
                is_enroute: delTracking.is_enroute,
                delivered: delTracking.delivered,
                pod_name: delTracking.pod_name || "",
                show_on_map: delTracking.show_on_map,
                further_query_text: delTracking.further_query_text || "",
                tracking_token: delTracking.tracking_token || "",
                mapUrl: (delTracking.job_id >0 && delTracking.tracking_token !== ""? config.driverGpsUrl : ""),
                redirect: (delTracking.job_id <= 0)    
            });            
        })
        .catch(error => {
            console.log(error);
            this.setState({redirect: true});
        });
    }
    
    openPopup() {        
        if (redirect === true)
            <Navigate to="/Login" />
            window.open(this.state.url, "popup_id", "scrollbars,resizable,width="+720+",height="+540);        
    }

    render() {
        if (this.state.redirect === true) {
            return <Navigate to="/login" />
        }
        
        return (
            <div id="delivery-tracking-details">
                <div className="container-fluid padding-lr55">
                    <div className="navbar-header">
                        <a href={config.companyUrl}>
                            <img styleName="styles.logo" src={DeadLineExpress} alt="Deadline Express" />
                        </a>
                    </div>
                </div>

                <div className="container-fluid padding-lr55 bg-form flat">
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <div className="row h3">
                                <div className="col-xs-12">Tracking Number: {this.state.job_number} </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <div className="row h3">
                                <div className="col-xs-12">Job Status: {this.state.job_status} </div>
                            </div>
                            <div><br /></div>
                        </div>
                    </div>                    
                    <div className="row h4">
                        <div className="col-xs-12">
                            <FurtherQueryText delivered={this.state.delivered} />
                        </div> 
                    </div>
                </div>

                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-xs-12">
                            <DeliveryTrackingStepper
                                job_status={this.state.job_status}
                                booked={this.state.booked}
                                in_progress={this.state.in_progress}
                                picked_up={this.state.picked_up}
                                is_enroute={this.state.is_enroute}
                                delivered={this.state.delivered}
                                />
                        </div>
                    </div>
                </div>                

                {/* only show the pod name for final delivery */}
                {this.state.delivered &&
                    <div className="container-fluid padding-lr55 bg-form flat">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <div className="row h3">
                                    <div className="col-xs-12" >Delivery received by: {this.state.pod_name} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* show driver gps location if required */}
                {this.state.show_on_map &&
                    <div className="container-fluid padding-lr55 bg-form flat">
                        <div className="row">
                            <IframeTracking url={this.state.mapUrl+this.state.tracking_token} />
                        </div>
                    </div>
                }
                
            </div>
        );
    }
} 

const trackingPage = withRouter(DeliveryTrackingPage);
export { trackingPage as DeliveryTrackingPage }; 
